// permission-guard.ts
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-loader.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { currentUser } from "@adornis/users/client/currentUser.js";
import { GLOBAL_CONTEXT } from "@adornis/users/db/a-roles.js";
import { html, nothing } from "lit";
import { AsyncDirective, directive } from "lit/async-directive.js";
var PermissionGuard = class extends AsyncDirective {
  constructor(partInfo) {
    super(partInfo);
    this._currentUser = currentUser();
    this.currentUserLoaded = true;
    this.host = partInfo.options.host;
    this.currentUserSubscription = this._currentUser.dataFeed.subscribe(({ data, fullyLoaded }) => {
      this.currentUser = data;
      this.currentUserLoaded = fullyLoaded;
      if (this.props)
        this.setValue(this.getCorrectTemplate(this.props));
    });
  }
  render(permission, template, options) {
    return this.getCorrectTemplate({
      guardedTemplate: template,
      permission,
      options
    });
  }
  update(_part, [permission, guardedTemplate, options]) {
    return this.getCorrectTemplate({
      permission,
      guardedTemplate,
      options
    });
  }
  disconnected() {
    this.currentUserSubscription?.unsubscribe();
  }
  getCorrectTemplate({
    permission,
    guardedTemplate,
    options: {
      forbiddenTemplate = nothing,
      context = GLOBAL_CONTEXT,
      loadingTemplate = xComponents(html` <x-flex h100 w100 center crossaxis-center> <x-loader></x-loader> </x-flex>`)
    } = {}
  }) {
    if (!guardedTemplate)
      throw new Error("permissionGuard got nothing to guard");
    if (!permission)
      throw new Error("Permission is not set");
    this.props = {
      permission,
      guardedTemplate,
      options: {
        forbiddenTemplate,
        loadingTemplate,
        context
      }
    };
    if (!this.currentUserLoaded)
      return typeof loadingTemplate === "function" ? loadingTemplate.call(this.host) : loadingTemplate;
    if (this.currentUser?.hasPermission(permission, context))
      return guardedTemplate.call(this.host);
    return typeof forbiddenTemplate === "function" ? forbiddenTemplate.call(this.host) : forbiddenTemplate;
  }
};
var permissionGuard = directive(PermissionGuard);
export {
  PermissionGuard,
  permissionGuard
};
